export default "__VITE_ASSET__D2XV1AGo__"